
export default "/assets/arrow-right-start-on-rectangle-micro.db0c8afc.svg"